import './styles.scss'

import React from 'react'
import { useValues } from 'kea'

import courseLogic from '~/scenes/course/show/logic'

export default function Breadcrumbs () {
  const {
    course: {
      breadcrumbs: { root, categories }
    }
  } = useValues(courseLogic)

  return (
    <div className='tightrow'>
      <div className='twelve columns main-screen'>
        <div className='course-breadcrumbs'>
          <div className='breadcrumb'>
            <strong>
              <a href={root.url} rel='home'>
                <em>{root.title}</em>
              </a>
            </strong>
            <div className='breadcrumb-child'>
              <div className='main'>
                {categories.map(category => (
                  <div className='with-comma' key={category.id}>
                    <a href={category.url}>
                      <em>{category.title}</em>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
